export default{
    title: 'Dashboard',
    welcome: 'Welcome to Athlisis',
    educational: 'Educational',
    welcomeText: 'The No1 application for dietitians in Greece!',
    confirmEmail: {
        title: 'You haven\'t confirmed your e-mail address.',
        cta: 'Re-send confirmation e-mail'
    },
    news: {
        title: 'Latest news',
        subtitle: 'Read our latest news in our blog',
        cta: 'Read more'
    },

    birthdays: {
        title: 'Clients who have their birthday this month',
        subtitle: 'Don\'t forget to send them your wishes!',
        noResults: 'No more birthdays this month',
        noResultsText: 'Only clients with a birth date on file are shown.',
        phone: 'Phone:',
        cta: 'View',
    },
    addAthlete: 'Add client',
    addAppointment: 'Add appointment',
    addAppointmentModalTitle: 'Add appointment',
    events: {
        title: 'Today\'s appointments',
        subtitle: 'View your next appointments for the day',
        noEvents: 'No more appointments today',
        noEventsText: 'If you book a new appointment for today, it will show up here.',
        showCancelledQ: 'Show cancelled?',
        cancelled: 'Cancelled',
        dailyAppointments: 'Today\'s Appointment',
        hour: 'Hour',
        client: 'Client - Note',
        next: {
            ongoing: 'You have an appointment in progress right now',
            startsIn: 'Your next appointment starts in {time}',
            hours: '{count} hour | {count} hours',
            minutes: '{count} minute | {count} minutes',
            and: 'and',
        },
    },
    todo: {
        title: 'To-do list',
        active: 'Active',
        completed: 'Completed',
        add: 'Add new to-do',
        emptyActive: 'All caught up',
        emptyActiveText: 'Nothing pending.',
        emptyCompleted: 'No completed to-dos yet',
        emptyCompletedText: 'Whatever you complete will show up here.',
        dateToday: 'today',
        dateYesterday: 'yesterday',
        dateDaysAgo: '{days} days ago'
    },
    aiAgents: {
        title: 'athlisis meets AI',
        badge: 'NEW',
        text: 'Give Claude and ChatGPT access to your account data — let them help with clients, plans and daily admin.',
        connect: 'Connect now',
    },
    marketplace: {
        title: 'Get found on vresdiatrofologo',
        text: 'Create your free profile and grow your visibility.',
        createAccount: 'Create account',
        readMore: 'Read more',
        panel: {
            title: 'vresdiatrofologo',
            videoPlaceholder: 'A short walkthrough video will appear here soon.',
            p1: '<strong>vresdiatrofologo.gr</strong> is Athlisis\'s new tool for the modern dietitian.',
            p2: 'Every day people search for a dietitian online — the question isn\'t whether they\'re searching, but whether they\'re finding you.',
            p3: 'With vresdiatrofologo you create your profile and appear based on your specialty, audience and results — so when someone is looking for a professional, they find you easily, accurately and high in the listings.',
            p4: 'The platform is evolving continuously to become the reference point for the field, and those who join early secure priority visibility.',
            p5: 'The process is simple and takes just 3–5 minutes. It\'s currently free exclusively for Athlisis users, as an extra tool to grow your professional profile.',
            p6: 'Start now and claim your spot among the first.',
            cta: 'Continue to vresdiatrofologo',
            ctaHelper: 'You\'ll be signed in automatically with your athlisis account.',
        }
    }
}